import React from 'react';
import PartnerCatalogPage from './PartnerCatalogPage';

const PartnerInventory = () => <PartnerCatalogPage kind="inventory" />;

export default PartnerInventory;
